var map = {
	"./area.svg": [
		"./src/icons/area.svg",
		"src_icons_area_svg"
	],
	"./back.svg": [
		"./src/icons/back.svg?1b79",
		"src_icons_back_svg"
	],
	"./data.svg": [
		"./src/icons/data.svg",
		"src_icons_data_svg"
	],
	"./expand.svg": [
		"./src/icons/expand.svg?b06a",
		"src_icons_expand_svg"
	],
	"./force.svg": [
		"./src/icons/force.svg",
		"src_icons_force_svg"
	],
	"./general_mode.svg": [
		"./src/icons/general_mode.svg?592d",
		"src_icons_general_mode_svg"
	],
	"./graphing_mode.svg": [
		"./src/icons/graphing_mode.svg?922e",
		"src_icons_graphing_mode_svg"
	],
	"./length.svg": [
		"./src/icons/length.svg",
		"src_icons_length_svg"
	],
	"./list.svg": [
		"./src/icons/list.svg?2594",
		"src_icons_list_svg"
	],
	"./more.svg": [
		"./src/icons/more.svg?bcc0",
		"src_icons_more_svg"
	],
	"./power.svg": [
		"./src/icons/power.svg",
		"src_icons_power_svg"
	],
	"./pressure.svg": [
		"./src/icons/pressure.svg",
		"src_icons_pressure_svg"
	],
	"./programming_mode.svg": [
		"./src/icons/programming_mode.svg?0032",
		"src_icons_programming_mode_svg"
	],
	"./remove.svg": [
		"./src/icons/remove.svg?75f0",
		"src_icons_remove_svg"
	],
	"./temperature.svg": [
		"./src/icons/temperature.svg",
		"src_icons_temperature_svg"
	],
	"./thermal.svg": [
		"./src/icons/thermal.svg",
		"src_icons_thermal_svg"
	],
	"./time.svg": [
		"./src/icons/time.svg",
		"src_icons_time_svg"
	],
	"./velocity.svg": [
		"./src/icons/velocity.svg",
		"src_icons_velocity_svg"
	],
	"./volume.svg": [
		"./src/icons/volume.svg",
		"src_icons_volume_svg"
	],
	"./weight.svg": [
		"./src/icons/weight.svg",
		"src_icons_weight_svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/icons lazy recursive ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;